module.exports = __webpack_public_path__ + "img/pastel-smear-image-2.39b7954e.jpg";